export default {
  faq: {
    en: 'FAQ',
    fr: 'FAQ',
  },
  question: {
    en: 'Q',
    fr: 'Q',
  },
  answer: {
    en: 'A',
    fr: 'R',
  },
  question_implication: {
    en: 'What is the level of implication required?',
    fr: "Quel est le niveau d'implication requis?",
  },
  answer_implication: {
    en: 'We do not impose hours on our members, but we ask for clear communication about unavailability. It is encouraged to complete hours for the Génie+ mention.',
    fr: "Nous n'imposons pas d'heures à nos membres, mais nous demandons une communication claire sur les indisponibilités. Il est encouragé de faire des heures pour la mention Génie+.",
  },
  question_skills: {
    en: 'What skills are you looking for?',
    fr: 'Quelles compétences recherchez-vous?',
  },
  answer_skills: {
    en: "We are looking for people who don't hesitate to ask the right questions and who are independent. We encourage learning and design tutorials to introduce new members. It's a plus to know Fusion, Altium and ROS.",
    fr: "Nous recherchons des gens qui n'hésitent pas à poser les bonnes questions et qui sont autonome. Nous encourageons l'apprentissage et concevons des tutoriels pour initier les nouveau membres. C'est un plus de connaitre Fusion, Altium et ROS.",
  },
  question_apply: {
    en: 'How can I apply?',
    fr: 'Comment puis-je postuler?',
  },
  answer_apply: {
    en: 'To apply, please complete the "Adhésion aux clubs étudiants" form on ÉTS Formaires and do not hesitate to visit us for more information.',
    fr: 'Pour postuler, veuillez remplir le formulaire "Adhésion aux clubs étudiants" sur ÉTS Formulaires et n\'hésitez pas à nous visiter pour plus d\'informations.',
  },
  question_recruitment_period: {
    en: 'When is the recruitment period?',
    fr: 'Quand est la période de recrutement?',
  },
  answer_recruitment_period: {
    en: 'The recruitment period typically starts in September but we accept members at any time.',
    fr: "La période de recrutement commence généralement en septembre, mais nous acceptons des membres à n'importe quel moment.",
  },
  question_visit: {
    en: 'Can I visit your club?',
    fr: 'Puis-je visiter votre club?',
  },
  answer_visit: {
    en: 'Yes! We are always happy to welcome visitors to our club. Please contact us to schedule a visit.',
    fr: "Oui! Nous sommes toujours heureux d'accueillir des visiteurs dans notre club. Veuillez nous contacter pour planifier une visite.",
  },
};
